export function collectionModal (options = {}) {

    // Valeur par défaut si aucune option fournie
    const defaultOptions = {
        create_btn: null, // texte du bouton si besoin
    };
    let main_geojson;

    // Fusion des options
    options = { ...defaultOptions, ...options };

    /**
     * Création du bouton pour le lancement de la modal
     * @returns JQuery element
     */  
    function getButtonView() {
         // Supprimer le précédent si présent
        $('[data-action="open_modal_collection"]').remove();
        
        let buttonView = $(`
            ${ options.create_btn ? 
                `<div><a class="cursor-pointer" data-action="open_modal_collection">${options.create_btn}</a></div>` 
                : 
                `<div><a class="cursor-pointer btn" data-action="open_modal_collection"><span>Modal Collections</span></a></div>`}
        `);
        bindEventButton( buttonView );
        return buttonView;
    }

    function bindEventButton($el) {
        $el.off("click", "[data-action='open_modal_collection']"); // nettoie les anciens handlers
        $el.on("click", "[data-action='open_modal_collection']", function (e) {
        e.preventDefault();

        // Interaction avec le plugin React
        if (window.pluginCollection) {
            window.pluginCollection.openColletionModal(main_geojson); 
        } else {
            console.warn("Le plugin CollectionPlugin n'est pas encore initialisé !");
        }
        });
    }

    function init( geojson ){
        if(checkEnv()){
            if(geojson == null || geojson == undefined){
                console.error('geojson option must be of type GeoJSON https://fr.wikipedia.org/wiki/GeoJSON.');
            }else{
                setGeoJson(  geojson )
                if(main_geojson == null){
                    console.error('geojson option must be of type GeoJSON https://fr.wikipedia.org/wiki/GeoJSON.');
                }
            }
        }
    }

    function setGeoJson( geojson ){
        main_geojson = geojson;
        return main_geojson;
    }

    /**
     * Permet de checker l'environnement et les prérequis.
     * @return {boolean} true si tout est ok, false sinon. 
     */
	function checkEnv(){
		let returned = true;
		if(typeof $ !== 'function'){
			console.error('Jquery needs to be imported');
			returned = false;
		}
		if(options.api_collection == undefined){
            console.error('api_collection option must be defined.')
			returned = false;
		}
        if(options.user_data == undefined){
            console.error('user_data option must be defined.')
			returned = false;
		}
		return returned;
	}

  
    let callable = {
        getButtonView:   ()          =>  getButtonView(),
        init:           ( geojson ) =>  init( geojson ),
    }
    return callable;
};
  